export const linkbulder = (size = 'm', link) => {
  let images = ['_' + size + '.webp', '_' + size + '.png']
  images = images.map(value => {
    return link + value
  })
  return images
}
